import { Building2, User, MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { COMPANY_INFO } from "@/constants/nav";

export const ContactInfo = () => {
  return (
    <section data-testid="contact-info" className="bg-[#F2F9F5] border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl">
          <div data-testid="contact-info-company" className="flex items-start gap-3">
            <Building2 className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Company</p>
              <p className="text-sm text-slate-600">{COMPANY_INFO.name}</p>
            </div>
          </div>
          <div data-testid="contact-info-owner" className="flex items-start gap-3">
            <User className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Owner</p>
              <p className="text-sm text-slate-600">{COMPANY_INFO.owner}</p>
            </div>
          </div>
          <div data-testid="contact-info-phone" className="flex items-start gap-3">
            <Phone className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Phone / WhatsApp</p>
              <a href={COMPANY_INFO.whatsappLink} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-600 hover:text-[#0B4F37]">
                {COMPANY_INFO.whatsappDisplay}
              </a>
            </div>
          </div>
          <div data-testid="contact-info-hours" className="flex items-start gap-3">
            <Clock className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Working Hours</p>
              <p className="text-sm text-slate-600">{COMPANY_INFO.workingHours}</p>
            </div>
          </div>
          <div data-testid="contact-info-email-primary" className="flex items-start gap-3">
            <Mail className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Primary Email</p>
              <a href={`mailto:${COMPANY_INFO.emailPrimary}`} className="text-sm text-slate-600 hover:text-[#0B4F37] break-all">
                {COMPANY_INFO.emailPrimary}
              </a>
            </div>
          </div>
          <div data-testid="contact-info-email-secondary" className="flex items-start gap-3">
            <Mail className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Secondary Email</p>
              <a href={`mailto:${COMPANY_INFO.emailSecondary}`} className="text-sm text-slate-600 hover:text-[#0B4F37] break-all">
                {COMPANY_INFO.emailSecondary}
              </a>
            </div>
          </div>
          <div data-testid="contact-info-address" className="flex items-start gap-3 sm:col-span-2">
            <MapPin className="h-5 w-5 mt-0.5 shrink-0 text-[#0B4F37]" strokeWidth={1.8} />
            <div>
              <p className="text-sm font-semibold text-[#042D1F]">Address</p>
              <p className="text-sm text-slate-600">{COMPANY_INFO.address}</p>
            </div>
          </div>
        </div>

        <a
          href={COMPANY_INFO.mapsLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-maps-button"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#0B4F37] text-[#0B4F37] font-semibold px-6 py-3 hover:bg-white transition-colors"
        >
          View Location on Google Maps
          <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </section>
  );
};
